import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { SaveMission } from '../../../store/actions/mission.actions';
import { LinesService } from '../../../../lines/services/lines.service';

@Component({
    selector: 'app-activate-new-sim-card',
    templateUrl: './activate-new-sim-card.component.html',
    styleUrls: ['./activate-new-sim-card.component.css'],
    standalone: false
})
export class ActivateNewSimCardComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;
  simCardErrorMessage: string|null;
  step: number;
  form: FormGroup;
  errorMessage: string|null;
  submitted: boolean;
  iccid: string|null;
  errors: any = {
    simCardNumber: {
      required: `Le numéro de la carte sim est obligatoire.`,
      pattern: `Le numéro de la carte sim n'est pas valide.`
    }
  };
  constructor(
      private store: Store<any>,
      private formBuilder: FormBuilder,
      private linesService: LinesService
  ) { }

  ngOnInit() {
    this.step = 1;
    this.submitted = false;
    this.iccid = null;
    this.initForm();
  }

  initForm() {
    this.submitted = false;
    this.form = this.formBuilder.group({});
    this.form.addControl('simCardNumber', this.formBuilder.control( '', [Validators.required]));
  }
  checkSimCardNumber() {
    this.submitted = true;
    if (this.form.valid) {
      this.linesService.checkAvailableSim(this.form.get('simCardNumber').value).subscribe(
          response => {
            this.step = 2;
            this.iccid = this.form.get('simCardNumber').value;
          }, error => {
            this.simCardErrorMessage = 'Le numéro de la carte SIM est invalide.';
          });
    }
  }
  submit() {
    this.store.dispatch(
        new SaveMission(
            {
              iccid: this.iccid,
              phoneNumber: this.line.phoneNumber,
            },
            ConstsHelper.PROCEDURE_ACTIVATE_NEW_SIM_CARD
        )
    );
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setStep(step: number) {
    this.step = step;
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.form.controls[formControlName].invalid) {
      Object.keys(this.form.controls[formControlName].errors).map(
          key => (errorMsg = this.errors[formControlName][key])
      );
    }
    return errorMsg;
  }
}
